import {isNil} from "../Helper";

export default function initNav() {
  const navOpener = document.querySelectorAll('.nav-opener');
  const activeClass = 'nav-active';

  navOpener.forEach((item) => {
    item.addEventListener('click', toggleActive);
  });

  const experienceMapTrigger = document.querySelector('#experience-map-trigger');
  if (!isNil(experienceMapTrigger)) {
    experienceMapTrigger.addEventListener('click', event => {
      closeNavbarIfOpen();
      window.document.location = event.target.closest('a').getAttribute('href');
    });
  }

  function toggleActive() {
    document.body.classList.toggle(activeClass);
  }

  function closeNavbarIfOpen() {
    if (document.body.classList.contains(activeClass)) {
      document.body.classList.toggle(activeClass);
    }
  }
}
